import * as Api from "@api";
import * as C from "@components";
import css from "./heating-consistency.module.scss";
import VadImage from "vadimages-nextjs-image-optimizer";

const HeatingConsistencyCardContentBaseKey = "heating-consistency" as const;
const imageDirectory = `/images/products/@global/cards/`;

export const HeatingConsistencyCardContentKeys = [
    `${HeatingConsistencyCardContentBaseKey}.headline`,
    `${HeatingConsistencyCardContentBaseKey}.body`,
    `${HeatingConsistencyCardContentBaseKey}.active`,
    `${HeatingConsistencyCardContentBaseKey}.competitor`,
] as const;

interface HeatingConsistencyCardProps
{
    hiddenOnMobile?: boolean;
    pageContent: Api.Content<typeof HeatingConsistencyCardContentKeys[number]>;
}

export const HeatingConsistencyCard = ({ pageContent, hiddenOnMobile = false }: HeatingConsistencyCardProps): React.FunctionComponentElement<HeatingConsistencyCardProps> =>
    <C.Card
        useWrapper
        hiddenOnMobile
        layout={{ all: { paddings: { all: C.Padding.D20 }, variant: C.CardVariant.CenteredContent, width: C.Width.W100P }, ipad: { paddings: { y: C.Padding.D86 } } }}
    >
        <C.SideBySideText
            className={css["heading"]}
            keys={[`${HeatingConsistencyCardContentBaseKey}.headline`, `${HeatingConsistencyCardContentBaseKey}.body`] as const}
            items={{
                [`${HeatingConsistencyCardContentBaseKey}.headline`]: { typography: C.Typography.H3, maxWidth: C.Width.W448 },
                [`${HeatingConsistencyCardContentBaseKey}.body`]: { typography: C.Typography.P2, maxWidth: C.Width.W424 }
            }}
            layout={{ all: { margins: { bottom: C.Margin.D20 } }, ipad: { margins: { bottom: C.Margin.D60 } } }}
            pageContent={pageContent}
        />
        <VadImage src={`${imageDirectory}${HeatingConsistencyCardContentBaseKey}-group.png`} alt={pageContent[`${HeatingConsistencyCardContentBaseKey}.headline`].data} width={920} height={190} />
    </C.Card>
